import React from 'react';

const ConfirmationPage = ({ bookingDetails, onBookAnother }) => {
  if (!bookingDetails) {
    return (
      <div className="confirmation-page">
        <h2>❌ Lỗi</h2>
        <p>Không tìm thấy thông tin đặt vé. Đã xảy ra lỗi.</p>
        <button className="book-another-btn btn btn-secondary btn-lg" onClick={onBookAnother}>
          Start Over
        </button>
      </div>
    );
  }

  return (
    <div className="confirmation-page">
      <h2>🎉 Đặt vé thành công!</h2>
      <p>Cảm ơn bạn đã đăng ký, <strong>{bookingDetails.name}</strong>!</p>
      <p>Chúng tôi đã giữ chỗ cho bạn cho phim <strong>Woodlawn</strong>:</p>

      <div className="confirmed-seats">
        {bookingDetails.seats.map(seatId => (
          <div key={seatId} className="confirmed-seat-item">
            <span className="seat-id">Seat {seatId}</span>
          </div>
        ))}
      </div>

      <p>Thông tin liên hệ: <strong>{bookingDetails.phone}</strong></p>
      <p>Hẹn gặp bạn tại sự kiện!</p>

      <div className="section-divider"></div>

      <div className="event-details-summary">
        <h3>Thông tin sự kiện:</h3>
        <div className="event-meta">
          <div className="meta-item">
            <span className="meta-text">Thứ Sáu, 7 Tháng 11, 2025</span>
          </div>
          <div className="meta-item">
            <span className="meta-icon">🕖</span>
            <span className="meta-text">19:00 (Mở cửa 18:45)</span>
          </div>
          <div className="meta-item">
            <span className="meta-icon">📍</span>
            <span className="meta-text">36 Đ. Số 2, An Phú, Thủ Đức, Thành phố Hồ Chí Minh</span>
          </div>
          <div className="meta-item">
            <span className="meta-icon">🔗</span>
            <span className="meta-text">
              <a href="https://maps.app.goo.gl/3aey8zn6RgKD7xx6A" target="_blank" rel="noopener noreferrer" className="location-link">
                Xem bản đồ Google Maps
              </a>
            </span>
          </div>
        </div>
      </div>

      <p>Rất mong được đón tiếp bạn!</p>

      <button className="book-another-btn btn btn-secondary btn-lg" onClick={onBookAnother}>
        Đặt cho người khác
      </button>
    </div>
  );
};

export default ConfirmationPage;
